/**
 * PageContent Component
 *
 * Provides consistent content area wrapper with standardized max-width,
 * padding, and centering across all pages
 */

import React, { type ReactNode } from 'react';
import { cn } from '../lib/utils';

export type ContentWidth = 'sm' | 'md' | 'lg' | 'xl' | 'full';

interface PageContentProps {
  /** Content to display */
  children: ReactNode;
  /** Maximum width of content area */
  width?: ContentWidth;
  /** Optional custom className */
  className?: string;
}

const widthClasses: Record<ContentWidth, string> = {
  sm: 'max-w-md', // 28rem / 448px - Login forms, narrow content
  md: 'max-w-4xl', // 56rem / 896px - Standard forms
  lg: 'max-w-6xl', // 72rem / 1152px - Data tables, lists
  xl: 'max-w-7xl', // 80rem / 1280px - Complex layouts, dashboards
  full: 'max-w-full', // Full width (still respects padding)
};

export function PageContent({ children, width = 'lg', className }: PageContentProps) {
  return <div className={cn('mx-auto px-8 py-8', widthClasses[width], className)}>{children}</div>;
}
